

export const ALL_MANAGERS = Array.from({ length: 50 }, (_, i) => ({
  id: `mgr-${i + 1}`,
  name: `Manager ${i + 1}`,
  candidates: Math.floor(Math.random() * 50) + 10,
  submissions: Math.floor(Math.random() * 30) + 5,
  interviews: Math.floor(Math.random() * 15) + 2,
  placements: Math.floor(Math.random() * 5),
}));


export const RECRUITERS_BY_MANAGER = {
  "mgr-1": [
    {
      id: "rec-1a",
      name: "Tom Baker",
      candidates: 12,
      submissions: 6,
      interviews: 3,
      placements: 1,
    },
    {
      id: "rec-1b",
      name: "Sara White",
      candidates: 9,
      submissions: 4,
      interviews: 2,
      placements: 0,
    },
    {
      id: "rec-1c",
      name: "Mike Green",
      candidates: 8,
      submissions: 5,
      interviews: 2,
      placements: 1,
    },
    {
      id: "rec-1d",
      name: "Anna Brown",
      candidates: 7,
      submissions: 3,
      interviews: 1,
      placements: 1,
    },
    {
      id: "rec-1e",
      name: "Chris Black",
      candidates: 6,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
    {
      id: "rec-1f",
      name: "Linda Gray",
      candidates: 5,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
    {
      id: "rec-1g",
      name: "Paul Stone",
      candidates: 4,
      submissions: 1,
      interviews: 0,
      placements: 0,
    },
    {
      id: "rec-1h",
      name: "Emma Wolf",
      candidates: 3,
      submissions: 1,
      interviews: 0,
      placements: 0,
    },
  ],
  "mgr-2": [
    {
      id: "rec-2a",
      name: "James Turner",
      candidates: 10,
      submissions: 7,
      interviews: 4,
      placements: 2,
    },
    {
      id: "rec-2b",
      name: "Olivia Hall",
      candidates: 8,
      submissions: 5,
      interviews: 3,
      placements: 1,
    },
    {
      id: "rec-2c",
      name: "Noah Adams",
      candidates: 7,
      submissions: 4,
      interviews: 2,
      placements: 1,
    },
    {
      id: "rec-2d",
      name: "Sophia Clark",
      candidates: 6,
      submissions: 3,
      interviews: 1,
      placements: 1,
    },
    {
      id: "rec-2e",
      name: "Liam Lewis",
      candidates: 5,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
    {
      id: "rec-2f",
      name: "Ava Walker",
      candidates: 4,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
  ],
  "mgr-3": [
    {
      id: "rec-3a",
      name: "Ethan Scott",
      candidates: 9,
      submissions: 5,
      interviews: 3,
      placements: 1,
    },
    {
      id: "rec-3b",
      name: "Isabella Young",
      candidates: 8,
      submissions: 4,
      interviews: 2,
      placements: 1,
    },
    {
      id: "rec-3c",
      name: "Mason King",
      candidates: 6,
      submissions: 3,
      interviews: 1,
      placements: 0,
    },
    {
      id: "rec-3d",
      name: "Mia Wright",
      candidates: 5,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
  ],
  "mgr-4": [
    {
      id: "rec-4a",
      name: "Lucas Harris",
      candidates: 15,
      submissions: 9,
      interviews: 5,
      placements: 2,
    },
    {
      id: "rec-4b",
      name: "Charlotte Martin",
      candidates: 12,
      submissions: 7,
      interviews: 4,
      placements: 2,
    },
    {
      id: "rec-4c",
      name: "Benjamin Garcia",
      candidates: 11,
      submissions: 6,
      interviews: 3,
      placements: 1,
    },
    {
      id: "rec-4d",
      name: "Amelia Nelson",
      candidates: 9,
      submissions: 5,
      interviews: 2,
      placements: 1,
    },
    {
      id: "rec-4e",
      name: "Elijah Carter",
      candidates: 8,
      submissions: 4,
      interviews: 2,
      placements: 0,
    },
    {
      id: "rec-4f",
      name: "Harper Mitchell",
      candidates: 6,
      submissions: 3,
      interviews: 1,
      placements: 0,
    },
    {
      id: "rec-4g",
      name: "Oliver Perez",
      candidates: 5,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
  ],
  "mgr-5": [
    {
      id: "rec-5a",
      name: "Jack Roberts",
      candidates: 7,
      submissions: 4,
      interviews: 2,
      placements: 1,
    },
    {
      id: "rec-5b",
      name: "Lily Evans",
      candidates: 6,
      submissions: 3,
      interviews: 1,
      placements: 0,
    },
    {
      id: "rec-5c",
      name: "Aiden Collins",
      candidates: 4,
      submissions: 2,
      interviews: 1,
      placements: 0,
    },
  ],
  // mgr-6 through mgr-12 each get 5 recruiters for demo
  "mgr-6": Array.from({ length: 5 }, (_, i) => ({
    id: `rec-6${String.fromCharCode(97 + i)}`,
    name: `Recruiter 6${String.fromCharCode(65 + i)}`,
    candidates: 8 - i,
    submissions: 4 - Math.floor(i / 2),
    interviews: 2,
    placements: i === 0 ? 1 : 0,
  })),
  "mgr-7": Array.from({ length: 6 }, (_, i) => ({
    id: `rec-7${String.fromCharCode(97 + i)}`,
    name: `Recruiter 7${String.fromCharCode(65 + i)}`,
    candidates: 10 - i,
    submissions: 5 - Math.floor(i / 2),
    interviews: 3,
    placements: i < 2 ? 1 : 0,
  })),
  "mgr-8": Array.from({ length: 4 }, (_, i) => ({
    id: `rec-8${String.fromCharCode(97 + i)}`,
    name: `Recruiter 8${String.fromCharCode(65 + i)}`,
    candidates: 6 - i,
    submissions: 3 - Math.floor(i / 2),
    interviews: 1,
    placements: 0,
  })),
  "mgr-9": Array.from({ length: 5 }, (_, i) => ({
    id: `rec-9${String.fromCharCode(97 + i)}`,
    name: `Recruiter 9${String.fromCharCode(65 + i)}`,
    candidates: 9 - i,
    submissions: 4 - Math.floor(i / 2),
    interviews: 2,
    placements: i === 0 ? 1 : 0,
  })),
  "mgr-10": Array.from({ length: 7 }, (_, i) => ({
    id: `rec-10${String.fromCharCode(97 + i)}`,
    name: `Recruiter 10${String.fromCharCode(65 + i)}`,
    candidates: 12 - i,
    submissions: 6 - Math.floor(i / 2),
    interviews: 3,
    placements: i < 3 ? 1 : 0,
  })),
  "mgr-11": Array.from({ length: 5 }, (_, i) => ({
    id: `rec-11${String.fromCharCode(97 + i)}`,
    name: `Recruiter 11${String.fromCharCode(65 + i)}`,
    candidates: 7 - i,
    submissions: 3 - Math.floor(i / 2),
    interviews: 2,
    placements: 0,
  })),
  "mgr-12": Array.from({ length: 6 }, (_, i) => ({
    id: `rec-12${String.fromCharCode(97 + i)}`,
    name: `Recruiter 12${String.fromCharCode(65 + i)}`,
    candidates: 9 - i,
    submissions: 4 - Math.floor(i / 2),
    interviews: 2,
    placements: i < 2 ? 1 : 0,
  })),
};


export const DEFAULT_COLUMN_HEADERS = [
  { label: "Candidates", key: "candidates" },
  { label: "Submissions", key: "submissions" },
  { label: "Interviews", key: "interviews" },
  { label: "Placements", key: "placements" },
];

export const PAGE_SIZE = 5;

/** Simulate async fetch — returns a slice of the full list */
export const fetchManagersPage = (page) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const start = (page - 1) * PAGE_SIZE;
      const slice = ALL_MANAGERS.slice(start, start + PAGE_SIZE);
      resolve({
        data: slice,
        hasMore: start + PAGE_SIZE < ALL_MANAGERS.length,
      });
    }, 600); // simulated network delay
  });

export const fetchRecruitersPage = (managerId, page) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const all = RECRUITERS_BY_MANAGER[managerId] ?? [];
      const start = (page - 1) * PAGE_SIZE;
      const slice = all.slice(start, start + PAGE_SIZE);
      resolve({
        data: slice,
        hasMore: start + PAGE_SIZE < all.length,
      });
    }, 500);
  });
